function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M47.31 27.17h-4a2 2 0 010-4h4a2 2 0 010 4zm-7.86-13.31A2 2 0 1136.62 11l2.83-2.82A2 2 0 0142.28 11zM25.31 37.17a12 12 0 1112-12 12 12 0 01-12 12zm0-20a8 8 0 108 8 8 8 0 00-8-7.99zm0-8a2 2 0 01-2-2v-4a2 2 0 014 0v4a2 2 0 01-2 2.01zm-14.14 4.69L8.34 11a2 2 0 012.83-2.82L14 11a2 2 0 11-2.83 2.83zM9.31 25.17a2 2 0 01-2 2h-4a2 2 0 110-4h4a2 2 0 012 2zm1.86 11.32A2 2 0 0114 39.31l-2.83 2.83a2 2 0 11-2.83-2.83zm14.14 4.68a2 2 0 012 2v4a2 2 0 01-4 0v-4a2 2 0 012-2zm14.14-4.68l2.83 2.82a2 2 0 01-2.83 2.83l-2.83-2.83a2 2 0 112.83-2.82z"
});

var SvgClearDay = function SvgClearDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 50.62 50.35",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClearDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clear-day.b257eb2b.svg";
export { ForwardRef as ReactComponent };